// TODO: REFACTOR? This is only used once, but probably should be used in other places
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ems-expense-status',
  templateUrl: './expense-status.component.html',
  styleUrls: ['./expense-status.component.scss'],
})
export class ExpenseStatusComponent implements OnInit {
  @Input() status = 'pending';

  // Generates a list of classes used to style status indicators
  statusClasses() {
    return {
      'is-approved': this.status === 'approved',
      'is-pending': this.status === 'pending',
      'is-fraudulent': this.status === 'fraudulent',
      'is-rejected': this.status === 'rejected',
    };
  }

  constructor() {}

  ngOnInit() {}
}
